module.exports = __webpack_public_path__ + "img/maj_2016.44f034a3.jpg";